import React from 'react';
import { Contract } from '../pages/Contract';

export const contractRoutePage = {
  component: <Contract />,
  route: '/contrato',
};
